module.exports = __webpack_public_path__ + "static/media/loader.d7dfdbba.gif";